import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Formik } from "formik";

import { login } from "../../services/auth";
import { fetchUser } from "../../services/auth";

import { setUser } from "../../reducer/userSlice";
import { setLoading } from "../../reducer/auth/auth";
import { setUpAuth, setRole } from "../../reducer/auth/auth";

import { userType } from "../../utils/utils";
import { getBrowserData } from "../../utils/helpers";
import {
  ONBOARDING_HOST_STORAGE_KEY,
  ONBOARDING_REDIRECT_VALUE,
  rememberOnboardingHost,
} from "../../utils/onboardingBooking";

import "./newlogin.css";

const Login = () => {
  //query params
  const [searchParams] = useSearchParams();
  const verifiedStatus = searchParams.get("message");
  const redirect_to = searchParams.get("redirect_to");
  const sendBack = searchParams.get("sendBack");
  const check_inservice = searchParams.get("check-in-service");

  //hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //states
  const [verified, setVerified] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [typePass, SetTypePass] = useState(true);
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    console.log(redirect_to, "searchParams", check_inservice);
    if (verifiedStatus) setVerified(verifiedStatus);
    if (redirect_to && redirect_to == "starter-booking") {
      localStorage.setItem("redirect_to", redirect_to);
    } else {
      localStorage.removeItem("redirect_to");
    }
    // Someone landing on the login URL itself (rather than through the gate page).
    if (redirect_to === ONBOARDING_REDIRECT_VALUE) {
      rememberOnboardingHost(searchParams.get("host"));
    }
  }, []);

  useEffect(() => {
    //for starter login and redirection
    if (sendBack) {
      localStorage.setItem("sendBack", "start");
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("sendBack");
      window.history.replaceState({}, document.title, newUrl.href);
    }
  }, []);

  const changePassType = (e) => {
    SetTypePass(!typePass);
  };

  const LoginUser = async (formData) => {
    localStorage.removeItem("guest_id");
    dispatch(setLoading(true));
    let item = {
      email: formData.email,
      password: formData.password,
    };
    let browserinfo = await getBrowserData();
    Object.assign(item, browserinfo);
    login(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          localStorage.setItem("access_token", data.data.data.access_token);
          dispatch(setUpAuth());
          callProfile(data.data.data.access_token);
        }
        if (
          !data.data.status &&
          data.data.error &&
          data.data.error !== "Unauthorized"
        ) {
          setEmailError(data.data.error);
        }
        if (!data.data.status && data.data.error === "Unauthorized") {
          setEmailError("Invalid Email or Password");
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };

  const callProfile = async (token) => {
    dispatch(setLoading(true));
    await fetchUser(token)
      .then((data) => {
        dispatch(setLoading(false));
        dispatch(setUser(data.data.data));
        renderUserType(data.data.data.usertype, data.data.data);
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };

  const renderUserType = (type, users) => {
    const user = userType(type);
    dispatch(setRole(user));
    const params = new URLSearchParams(window.location.search);
    if (params.has("check-in-service")) {
      window.location.href = "/check-in-service";
      return;
    }
    // Came in from a shared Onboarding Session link? App.js sends them back to it once
    // the role lands, so skip the normal home redirect here.
    if (localStorage.getItem(ONBOARDING_HOST_STORAGE_KEY) && user === "medium") {
      return;
    }
    if (user === "medium") {
      if (users.status === 1 && users.medium_status === 1) {
        navigate("/dashboard");
      } else {
        navigate("/profile");
      }
    }
    if (user === "admin") {
      navigate("/dashboard");
    }
    if (user === "client") {
      if (users.is_first_appointment) {
        navigate("/appointments");
      } else {
        navigate("/dashboard");
      }
    }
  };

  const redirectRoute = (item) => {
    navigate(item);
  };

  const openRegistrationModal = () => {
    setShowModal(true);
    window.loadModal2("#myModal", "show");
  };

  useEffect(() => {
    const modalEl = document.getElementById("myModal");

    if (!modalEl) return;

    const handleHide = () => {
      setShowModal(false);
    };

    modalEl.addEventListener("hidden.bs.modal", handleHide);

    return () => {
      modalEl.removeEventListener("hidden.bs.modal", handleHide);
    };
  }, []);

  // SVG Icons for email and password
  const EmailIcon = () => (
    <svg
      className="input-icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 6L12 13L2 6"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const PasswordIcon = () => (
    <svg
      className="input-icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <>
      {/* Bootstrap CDN Add karein */}
      {/* <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
        rel="stylesheet"
      /> */}

      <div className="login_body">
        <div className="header_login">
          <div className="header_container">
            <div className="header_left">
              <div className="logo">
                <img src="/images/logo-verysoul.png" alt="Very Soul Logo" />
              </div>
            </div>
            <div className="header_right">
              <span className="desktop-text">Don't have an account?</span>
              <span className="mobile-text"></span>
              <button className="register-btn" onClick={openRegistrationModal}>
                Register
              </button>
            </div>
          </div>
        </div>

        <div className="container-fluid login_content">
          <div className="row justify-content-center login_row">
            {/* Left Area */}
            <div className="card_column col-md-6 text-white bg-dark  login_left_area">
              <div className="card-body text-center">
                <div className="login_inner">
                  <div className="text-center login-heading">
                    <h2 className="d-none-text d-md-block force-md-block real-text">
                      Real Connection. Real Proof.
                    </h2>
                    <h2 className="d-block d-md-none">
                      Real Connection.
                      <br />
                      Real Proof.
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Area */}
            <div className="card_column col-md-6 p-4 mb-0 login_right_area">
              <div className="login_inner">
                <div className="card-body">
                  <h1>Login in to your account</h1>

                  {/* Error Messages */}
                  {emailError && (
                    <div className="alert alert-danger" role="alert">
                      {emailError}
                    </div>
                  )}
                  {verified && (
                    <div className="alert alert-success" role="alert">
                      {verified}
                    </div>
                  )}

                  <Formik
                    initialValues={{
                      email: "",
                      password: "",
                    }}
                    validate={(values) => {
                      const errors = {};
                      if (!values.email) {
                        errors.email = "Required";
                      } else if (
                        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                          values.email
                        )
                      ) {
                        errors.email = "Invalid email address";
                      }
                      if (!values.password) errors.password = "Required";
                      if (values.password && values.password.length < 6)
                        errors.password = "Minimum length 6 character";

                      return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                      LoginUser(values);
                    }}
                    enableReinitialize={true}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                    }) => (
                      <form className="login_form" onSubmit={handleSubmit} autoComplete="off">
                        <div className="mb-4 mt-4 form-group">
                          <label>Email Address</label>
                          <div className="position-relative email-field-wrapper">
                            <div className="input-icon-wrapper">
                              <EmailIcon />
                            </div>
                            <input
                              className={`form-control ${
                                errors.email && touched.email && errors.email
                                  ? "error-boundry"
                                  : ""
                              }`}
                              type="email"
                              name="email"
                              placeholder="myemail@address.com"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.email}
                              autoComplete="off"
                            />
                          </div>
                          {errors.email && touched.email && (
                            <div className="error-text">{errors.email}</div>
                          )}
                        </div>

                        <div className="mb-3 form-group">
                          <label>Password</label>
                          <div className="position-relative password-field-wrapper">
                            <div className="input-icon-wrapper">
                              <PasswordIcon />
                            </div>
                            <input
                              className={`form-control ${
                                errors.password &&
                                touched.password &&
                                errors.password
                                  ? "error-boundry"
                                  : ""
                              }`}
                              type={typePass ? "password" : "text"}
                              name="password"
                              placeholder="Enter Password"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password}
                              autoComplete="off"
                            />
                            <div
                              className="password-toggle"
                              onClick={changePassType}
                            >
                              <img
                                src={
                                  typePass
                                    ? "/images/eye.png"
                                    : "/localImages/openeye.svg"
                                }
                                alt="toggle password visibility"
                                className={`eye-icon pointer ${
                                  typePass ? "" : "openeye"
                                }`}
                              />
                            </div>
                          </div>
                          {errors.password && touched.password && (
                            <div className="error-text">{errors.password}</div>
                          )}
                        </div>

                        {/* Forgot Password Section - Centered */}
                        <div className="forgot-password-row">
                          <span className="forgot-text">
                            Forgot your password?
                          </span>
                          <Link className="change-link" to="/forgot-password">
                            Change it here
                          </Link>
                        </div>

                        <div className="col-12">
                          <button
                            className="btn btn-primary px-4 login_button"
                            type="submit"
                           
                          >
                            Login
                          </button>
                        </div>
                      </form>
                    )}
                  </Formik>

                  <p className="text-body-secondary text-center mt-3">
                    <span>Not yet registered?</span>
                    <a
                      className="d5a67b ms-1 d-inline"
                      href="#"
                      onClick={openRegistrationModal}
                    >
                      Sign up here
                    </a>
                  </p>
                </div>

                <div className="login_bottom_area mt-4">
                  <div className="login_bottom_content">
                    <div className="login_bottom_links">
                      <ul>
                        <li>
                          <Link target="_blank" to="/privacy-policy">
                            Privacy Policy
                          </Link>
                        </li>
                        <li>
                          <Link target="_blank" to="/terms-conditions">
                            Terms & Conditions
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <p className="text- bookin">
                      <b>
                        Note: For optimum performance: use Chrome, Safari, or
                        Edge browser
                      </b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Registration Modal with all classes from old component */}
      {showModal && (
        <div className="dont-have-acc" onClick={() => setShowModal(false)}>
          <div
            className="modal fade"
            id="myModal"
            role="dialog"
            data-bs-backdrop="true"
            data-bs-keyboard="true"
          >
            <div
              className="modal-dialog modal-dialog-preview"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content">
                <div className="modal-body text-align-unset">
                  <div className="icon-pop text-align-center">
                    <img src="/images/Union-icon.png" alt="union-icon" />
                  </div>
                  <ul>
                    <li>
                      <div
                        onClick={() => redirectRoute("/registration")}
                        className="height-unset"
                        data-dismiss="modal"
                      >
                        <img src="/images/medum.png" alt="medium" />
                        <span data-dismiss="modal">
                          Register as <br />
                          Medium
                        </span>
                      </div>
                    </li>
                    <li>
                      <div
                        className="height-unset"
                        onClick={() => redirectRoute("/register-client")}
                        data-dismiss="modal"
                      >
                        <img src="/images/customer.png" alt="register" />
                        <span>
                          Register as <br />
                          Client
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
